export const SCOPES = {
  ADMIN: 'admin',
  SUPER_ADMIN: 'super-admin',
};
